// ── AllFundsPage ──
import { useState, useEffect } from "react";
import { B } from "../../../shared/theme";
import { fmtDate } from "../../../shared/format";
import { Badge, Btn, Card, ErrorMsg, Icon, STh, SectionHeader, Spinner, Td, TdNum, Th } from "../../../shared/ui";
import { useSortable } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const AllFundsPage = () => {
    const { api, role, view, setModal, setConfirm, delRec } = useApp();
      const [funds, setFunds] = useState([]);
      const [loading, setLoading] = useState(true);
      const [err, setErr] = useState(null);
      const load = () => {
        setLoading(true);
        api.get('getFunds').then(d => { setFunds(d); setLoading(false); }).catch(e => { setErr(e.message); setLoading(false); });
      };
      useEffect(() => { load(); }, []);

      const { sorted, sortKey, sortDir, toggle } = useSortable(funds, 'fundname');

      if (loading) return <Spinner />;
      if (err) return <ErrorMsg msg={err} onRetry={load} />;

      const active = funds.filter(f => f.status === 'Active');
      const closed = funds.filter(f => f.status === 'Closed');

      return <>
        <SectionHeader actions={[
          role.canManageUsers && <Btn key="a" onClick={() => setModal({ type: 'fund-add', onDone: load })} variant="primary">+ Add Fund</Btn>
        ].filter(Boolean)} />

        {/* Summary cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px,1fr))', gap: 12, marginBottom: 20 }}>
          <Card style={{ padding: 14 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: B.cyanDark, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>Active Funds</div>
            <div style={{ fontSize: 24, fontWeight: 600 }}>{active.length}</div>
          </Card>
          <Card style={{ padding: 14 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#888780', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>Closed Funds</div>
            <div style={{ fontSize: 24, fontWeight: 600 }}>{closed.length}</div>
          </Card>
          <Card style={{ padding: 14 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: B.cyanDark, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>Total Loans Owned</div>
            <div style={{ fontSize: 24, fontWeight: 600 }}>{active.reduce((s, f) => s + (f.loancount || 0), 0)}</div>
          </Card>
        </div>

        <Card style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', whiteSpace: 'nowrap' }}>
            <thead><tr>
              <STh label="Fund Name"   sortKey="fundname"   currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Status"      sortKey="status"     currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Start Date"  sortKey="startdate"  currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="End Date"    sortKey="enddate"    currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Active Loans" sortKey="loancount" currentKey={sortKey} currentDir={sortDir} onSort={toggle} numeric />
              <Th></Th>
            </tr></thead>
            <tbody>
              {sorted.map(f => (
                <tr key={f.id}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--color-background-secondary)'}
                  onMouseLeave={e => e.currentTarget.style.background = ''}>
                  <Td style={{ fontWeight: 500 }}>{f.fundname}</Td>
                  <Td><Badge s={f.status} /></Td>
                  <Td>{fmtDate(f.startdate)}</Td>
                  <Td>{f.enddate ? fmtDate(f.enddate) : '—'}</Td>
                  <TdNum>{f.loancount || 0}</TdNum>
                  <Td><div style={{ display: 'flex', gap: 6 }}>
                    <Btn onClick={() => setModal({ type: 'fund-view', rec: f })}><Icon type="view" /></Btn>
                    {role.canManageUsers && <Btn onClick={() => setModal({ type: 'fund-edit', rec: f, onDone: load })}><Icon type="edit" /></Btn>}
                    {role.canManageUsers && f.loancount === 0 && (
                      <Btn variant="danger" onClick={() => setConfirm({ msg: `Delete fund "${f.fundname}"?`, onConfirm: () => delRec('Funds', f.id, 'Deleted fund ' + f.fundname, load) })}>
                        <Icon type="delete" />
                      </Btn>
                    )}
                  </div></Td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      </>;
    };
